import { FC } from "react";
import { Icon } from "../../primitives";
import { THeadedSectionIconProps } from "./HeadedSection.config";

export const HeadedSectionIcon: FC<THeadedSectionIconProps> = ({ icon }) => {
  if (!icon) { return null; }

  return (
    <div className="w-5 h-5">
      <Icon icon={icon} />
    </div>
  );
};
